// 📁 src/helper-tools/image-service.js  
// SAFE QUALITY UPDATE - Your exact code + better quality options (Nothing will break!)

import { useState, useEffect } from 'react';

// 🔧 CONFIGURATION (Unchanged)
const IMAGE_CONFIG = {
  provider: 'cloudinary',
  cloudinary: {
    cloud_name: "fahadnimer"  
  }
};

// 📛 PROJECT DISPLAY NAMES (Unchanged)
const PROJECT_DISPLAY_NAMES = {
  najdar: {
    name: 'Najdar Brand Identity',
    shortName: 'Najdar',
    description: 'Cultural Brand Design'
  },
  sportship: {
    name: 'The Sportship Content',
    shortName: 'The Sportship', 
    description: 'Sports Media & Branding'
  },
  tonelab: {
    name: 'Tonelab Research',
    shortName: 'Tonelab',
    description: 'Brand Communication Library'
  },
  moodify: {
    name: 'Moodify Creative Tool',
    shortName: 'Moodify',
    description: 'Visual Moodboard Platform'
  },
  foundry: {
    name: 'Foundry AI Platform',
    shortName: 'Foundry',
    description: 'Business Insights Tool'
  },
  chibidash: {
    name: 'ChibiDash Experience',
    shortName: 'ChibiDash',
    description: 'Anime Interactive Platform'
  },
  'najdar-stays': {
    name: 'Najdar Stays Platform',
    shortName: 'Najdar Stays',
    description: 'Hospitality Web Experience'
  }
};

// CAPTION STYLES (Unchanged)
const CAPTION_STYLES = {
  simple: (projectInfo, index) => `${projectInfo.shortName} - Piece ${index + 1}`,
  detailed: (projectInfo, index) => `${projectInfo.name} - Portfolio Piece ${index + 1}`,
  descriptive: (projectInfo, index) => `${projectInfo.shortName} | ${projectInfo.description} - Image ${index + 1}`,
  numbered: (projectInfo, index, total) => `${projectInfo.shortName} (${index + 1} of ${total})`,
  portfolio: (projectInfo, index) => `${projectInfo.shortName}: Portfolio Work #${index + 1}`,
  clean: (projectInfo, index) => `${projectInfo.description}`,
  professional: (projectInfo, index) => `${projectInfo.shortName} - Work Sample ${index + 1}`
};

// PROJECT IMAGES (Unchanged)
const PROJECT_IMAGES = {
    najdar: [
      'najdar1', 'najdar2', 'najdar3', 'najdar4', 'najdar5', 'najdar6', 'najdar7', 'najdar8', 'najdar9', 'najdar10',
      'najdar11', 'najdar12', 'najdar13', 'najdar14', 'najdar15', 'najdar16', 'najdar17', 'najdar18', 'najdar19', 'najdar20',
      'najdar21', 'najdar22', 'najdar23', 'najdar24', 'najdar25', 'najdar26', 'najdar27', 'najdar28', 'najdar29', 'najdar30', 'najdar31'
    ],
    sportship: [
      'thesportship1', 'thesportship2', 'thesportship3', 'thesportship4', 'thesportship5', 'thesportship6', 'thesportship7', 'thesportship8', 'thesportship9', 'thesportship10',
      'thesportship11', 'thesportship12', 'thesportship13', 'thesportship14', 'thesportship15', 'thesportship16', 'thesportship17', 'thesportship18', 'thesportship19', 'thesportship20',
      'thesportship21', 'thesportship22', 'thesportship23', 'thesportship24', 'thesportship25', 'thesportship26', 'thesportship27', 'thesportship28', 'thesportship29', 'thesportship30',
      'thesportship31', 'thesportship32'
    ],
    tonelab: [],
    moodify: [],
    foundry: [],
    chibidash: []
};

// 🎨 ENHANCED QUALITY TRANSFORM PRESETS (Your old ones + new quality options)
export const transforms = {
  // 🔧 YOUR EXISTING TRANSFORMS (Unchanged - everything still works!)  
  thumb: 'w_300,h_200,c_fill,q_90,f_auto',        // 90% quality
  mobile: 'w_400,q_95,f_auto',                    // 95% quality
  tablet: 'w_800,q_95,f_auto',                    // 95% quality 
  desktop: 'w_1200,q_95,f_auto',                  // 95% quality
  optimized: 'q_95,f_auto',                       // 95% quality
  ultra: 'q_100,f_auto',                          // Maximum quality (your current default)
  
  // 🏆 NEW QUALITY OPTIONS (Added - use these for even better quality)
  original: '',                                   // No transforms - absolute maximum quality
  perfect: 'q_100,f_auto,fl_progressive',         // 100% quality + progressive loading
  portfolio: 'q_98,f_auto,fl_progressive',        // 98% quality for portfolios
  showcase: 'q_100,f_webp,fl_progressive',        // 100% WebP (smaller files, same quality)
  
  // 📱 NEW RESPONSIVE HIGH QUALITY OPTIONS
  mobile_hq: 'w_600,q_98,f_auto,fl_progressive',    // Mobile high quality
  tablet_hq: 'w_1000,q_98,f_auto,fl_progressive',   // Tablet high quality  
  desktop_hq: 'w_1600,q_100,f_auto,fl_progressive', // Desktop maximum quality
  
  // 🎯 NEW SPECIALIZED OPTIONS (Use for hero images, lightboxes, etc.)
  hero: 'w_1920,q_100,f_auto,fl_progressive',       // Hero sections
  lightbox: 'w_2000,q_100,f_auto,fl_progressive',   // Lightbox/modal images
  zoom: 'w_2400,q_100,f_auto,fl_progressive'        // For zoom functionality
};

// 📸 CLIENT-SIDE ADAPTER (Unchanged - your exact code)
const clientSideAdapter = {
  async fetchImages(projectName, maxResults = 50) {
    console.log('🚀 Client-side fetch for project:', projectName);
    
    try {
      const config = IMAGE_CONFIG.cloudinary;
      const imageList = PROJECT_IMAGES[projectName] || [];
      
      console.log('📋 Found image list for', projectName, ':', imageList.length, 'images');
      
      if (imageList.length === 0) {
        console.warn('⚠️ No images defined for project:', projectName);
        return [];
      }
      
      const projectInfo = PROJECT_DISPLAY_NAMES[projectName] || {
        name: projectName.charAt(0).toUpperCase() + projectName.slice(1),
        shortName: projectName.charAt(0).toUpperCase() + projectName.slice(1),
        description: 'Portfolio Work'
      };
      
      const captionStyle = 'detailed';
      
      const images = imageList.slice(0, maxResults).map((publicId, index) => {
        const imageUrl = `https://res.cloudinary.com/${config.cloud_name}/image/upload/${publicId}`;
        
        console.log(`🖼️ Creating image ${index + 1}:`, imageUrl);
        
        const caption = CAPTION_STYLES[captionStyle] 
          ? CAPTION_STYLES[captionStyle](projectInfo, index, imageList.length)
          : `${projectInfo.shortName} - Piece ${index + 1}`;
        
        return {
          id: `${projectName}-${index}`,
          publicId: publicId,
          src: imageUrl,
          alt: `${projectInfo.name} Image ${index + 1}`,
          width: 800,
          height: 600,
          caption: caption
        };
      });
      
      console.log(`✅ Generated ${images.length} images for "${projectInfo.name}"`);
      return images;
      
    } catch (error) {
      console.error('💥 Client-side fetch error:', error);
      return [];
    }
  },

  transformUrl(originalUrl, transforms) {
    if (!transforms || transforms === '') {
      return originalUrl; // Return original if no transforms
    }
    const transformedUrl = originalUrl.replace('/upload/', `/upload/${transforms}/`);
    console.log('🎨 Transform URL:', originalUrl, '→', transformedUrl);
    return transformedUrl;
  }
};

// PROVIDERS (Unchanged)
const providers = {
  cloudinary: clientSideAdapter
};

// FETCH PROJECT IMAGES (Unchanged)
export const fetchProjectImages = async (projectName, maxResults = 50) => {
  console.log('🎯 fetchProjectImages called with:', projectName);
  
  if (!PROJECT_IMAGES[projectName]) {
    const error = `Unknown project: ${projectName}. Available: ${Object.keys(PROJECT_IMAGES).join(', ')}`;
    console.error('❌', error);
    throw new Error(error);
  }

  const provider = providers[IMAGE_CONFIG.provider];
  return provider.fetchImages(projectName, maxResults);
};

// TRANSFORM IMAGE URL (Unchanged)
export const transformImageUrl = (originalUrl, transform) => {
  const provider = providers[IMAGE_CONFIG.provider];
  const transformString = transforms[transform] || transform;
  
  return provider.transformUrl(originalUrl, transformString);
};

// 🎯 REACT HOOK (Unchanged - keeps your current 'ultra' default)
export const useProjectImages = (projectName, transform = 'ultra') => { // ← Keeping your current default!
  console.log('🪝 useProjectImages hook called:', projectName, transform);
  
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    console.log('🔄 useEffect triggered for:', projectName);
    
    if (!projectName) {
      const errorMsg = 'Project name is required';
      console.error('❌', errorMsg);
      setError(errorMsg);
      setLoading(false);
      return;
    }

    const loadImages = async () => {
      try {
        console.log('⏳ Starting to load images...');
        setLoading(true);
        setError(null);
        
        const fetchedImages = await fetchProjectImages(projectName);
        console.log('📥 Fetched', fetchedImages.length, 'images');
        
        const transformedImages = fetchedImages.map(img => ({
          ...img,
          src: transform ? transformImageUrl(img.src, transform) : img.src
        }));
        
        console.log('✨ Final transformed images ready:', transformedImages.length);
        setImages(transformedImages);
        
      } catch (err) {
        console.error('💥 Hook error:', err);
        setError(err.message);
      } finally {
        console.log('🏁 Loading finished');
        setLoading(false);
      }
    };

    setTimeout(loadImages, 500);
    
  }, [projectName, transform]);

  return { images, loading, error };
};

// 🆕 BONUS: Quality testing utility (New - won't affect existing code) 
export const testImageQuality = (publicId) => {
  const cloudName = IMAGE_CONFIG.cloudinary.cloud_name;
  
  const qualityTests = {
    current: `https://res.cloudinary.com/${cloudName}/image/upload/q_100,f_auto/${publicId}`,    // Your current ultra
    original: `https://res.cloudinary.com/${cloudName}/image/upload/${publicId}`,                // Maximum quality  
    portfolio: `https://res.cloudinary.com/${cloudName}/image/upload/q_98,f_auto,fl_progressive/${publicId}`, // New option
    perfect: `https://res.cloudinary.com/${cloudName}/image/upload/q_100,f_auto,fl_progressive/${publicId}`   // New option
  };
  
  console.log('🔍 Quality Test URLs for', publicId, ':', qualityTests);
  return qualityTests;
};